import { GoatAwkward, useIntl } from '@capsicum/common';
import { GenericDrawer } from '@capsicum/common-web';

export type CHZOnHoldDrawerProps = {
	closeModal: () => void;
	minAmount?: string;
	testID: string;
};

export const CHZOnHoldDrawer = ({ closeModal, minAmount, testID }: CHZOnHoldDrawerProps) => {
	const { $t } = useIntl();

	const cHZOnHoldDrawerData = {
		buttonText: $t('wallet.withdraw.cHZOnHoldDrawer.buttonText'),
		description: $t('wallet.withdraw.cHZOnHoldDrawer.description', { minAmount }),
		image: GoatAwkward,
		testID: testID,
		title: $t('wallet.withdraw.cHZOnHoldDrawer.title')
	};

	return <GenericDrawer {...cHZOnHoldDrawerData} onButtonPress={closeModal}></GenericDrawer>;
};
